import PopupMenu from '@osmosis/nextjs-components/PopupMenu/PopupMenu';
export * from '@osmosis/nextjs-components/PopupMenu/PopupMenu';
export default PopupMenu;
